/**
 * E135.F2.C02 (F-E135.F2-02, ADR-0091): os envios do caso com arquivo e sem conclusão, lidos do
 * recibo gravado ao montar. É como Adicionar documentos, na mesa, mostra depois de recarregar a
 * página o recibo que ficou aberto. A abertura não usa: ela já lê o recibo a cada envio.
 *
 * E135.F2.C03 (F-E135.F2-03): a leitura que falha não é recibo sem envio aberto. `naoLido` diz que não
 * se sabe, e `lerDeNovo` repete a leitura.
 */
import { useCallback, useEffect, useState } from 'react';
import type { AxiosInstance } from 'axios';

import { lerAberturaDoCaso, recebimentosAbertos } from '@/lib/abertura_do_caso';

export interface RecibosAbertos {
  abertos: readonly string[];
  /** A leitura do recibo falhou: não se sabe se algum envio ficou aberto. */
  naoLido: boolean;
  lerDeNovo: () => void;
}

interface Leitura {
  abertos: readonly string[];
  naoLido: boolean;
}

const INICIAL: Leitura = { abertos: [], naoLido: false };

export function useRecebimentosAbertos(client: AxiosInstance, caseId: string): RecibosAbertos {
  const [leitura, setLeitura] = useState<Leitura>(INICIAL);
  const [vez, setVez] = useState(0);
  useEffect(() => {
    let ativo = true;
    lerAberturaDoCaso(client, caseId)
      .then(({ recibo }) => {
        if (ativo) setLeitura({ abertos: recebimentosAbertos(recibo), naoLido: false });
      })
      .catch(() => {
        // O que já se sabia fica; o mesmo objeto, quando já estava não lido, não renderiza de novo.
        if (ativo) setLeitura((atual) => (atual.naoLido ? atual : { ...atual, naoLido: true }));
      });
    return () => {
      ativo = false;
    };
  }, [client, caseId, vez]);
  const lerDeNovo = useCallback(() => setVez((n) => n + 1), []);
  return { ...leitura, lerDeNovo };
}
